import { FC, useState, useRef } from "react";

interface HoverPopoverProps {
  label: string;
  children: { label: string; value: string; roles: string[] }[];
  onNavigate: (value: string) => void;
  active: boolean;
}

const HoverPopover: FC<HoverPopoverProps> = ({ label, children, onNavigate, active }) => {
  const [open, setOpen] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setOpen(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setOpen(false);
    }, 500); // 1.5s delay before closing
  };

  console.log("active-label", active, label);
  return (
    <div
      className="relative inline-block"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className={`${active ? "text-purple-400" : ""} hover:text-purple-400 cursor-pointer`}
      >
        {label}
      </button>

      {open && (
        <div
          className="absolute left-0 top-full mt-2 w-48 bg-white shadow-lg rounded-lg border z-50"
          onMouseEnter={handleMouseEnter} // keep open if cursor enters dropdown
          onMouseLeave={handleMouseLeave} // start close delay if leaving dropdown
        >
          <ul className="flex flex-col p-2">
            {children.map((child) => (
              <li
              
                key={child.value}
                className={`${location.pathname?.toLowerCase()?.includes(child?.value?.toLowerCase()) ? "text-purple-400" : ""} px-3 py-2 rounded cursor-pointer hover:text-purple-400
                `}
                onClick={() => onNavigate(child.value)}
              >
                {child.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default HoverPopover;